import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'createdByApp',
})
export class CreatedByAppPipe implements PipeTransform {
  transform(value: string): any {
    let multiplier = {};
    if (value) {
      multiplier = JSON.parse(value);
      if (multiplier['appUserId']) {
        return multiplier['appUserId'];
      }
    } else {
      return '-';
    }
  }
}
